import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import {
  createObjectKey,
  CUSTOMER_STATUS,
  FUNCTION_RESULT_STATUS,
  ICustomer,
} from "@nova/common-interfaces";
import { IServicePlan, ISubscription } from "@rfm/shared-interfaces";
import { AutoComplete } from 'primeng/autocomplete';
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DatePickerModule } from "primeng/datepicker";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CustomerService } from "../../../../shared/services/customers/customers.service.mjs";
import { ServicePlanService } from "../../../../shared/services/products/service-plan.service.mjs";
import { SubscriptionService } from "../../../../shared/services/products/subscription.service.mjs";

@Component({
  selector: "app-subscription-view",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DatePickerModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    AutoComplete,
    ProgressSpinnerModule,
  ],
  templateUrl: "./subscription-create.component.html",
  styleUrls: ["./subscription-create.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SubscriptionCreateComponent implements OnInit {
  subscriptionForm!: FormGroup;
  selectedPlan: IServicePlan | undefined;
  selectedCustomer: ICustomer | undefined;
  activationDate: Date | undefined;
  name: string| undefined;

  customers: ICustomer[] = [];
  servicePlans: IServicePlan[] = [];
  filteredCustomers: ICustomer[] = [];
  filteredServicePlans: IServicePlan[] = [];

  isLoading = true;

  searchCustomers(event: any)
  {
    this.filteredCustomers = this.customers.filter(x => x.name?.toLowerCase().includes((event.query as string).toLowerCase()) && x.status !== CUSTOMER_STATUS.ARCHIVED);
  }

  searchServicePlans(event: any)
  {
    this.filteredServicePlans = this.servicePlans.filter(x => x.name?.toLowerCase().includes((event.query as string).toLowerCase()));
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private customerService: CustomerService,
    private servicePlanService: ServicePlanService
  ) {}

  ngOnInit(): void {
    this.subscriptionForm = this.fb.group({
      customer: ["", Validators.required],
      plan: ["", Validators.required],
    });

    const promises: Promise<any>[] = [];

    promises.push(this.customerService.getAll().then(async (result: any) => {
      if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
        console.error("Unbale to get customers");
        return Promise.reject("Unable to get customers");
      }

      this.customers = result.data!;
      this.filteredCustomers = this.customers;
    }));

    promises.push(this.servicePlanService.getAll().then(async (result: any) => {
      if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
        console.error("Unbale to get service plans");
        return Promise.reject("Unable to get service plans");
      }

      this.servicePlans = result.data!;
      this.filteredServicePlans = this.servicePlans;
    }));

    Promise.all(promises).then(() => {
      this.isLoading = false;
    })
  }

  onSubmit(): void {
    if (
      this.selectedCustomer &&
      this.selectedPlan
    ) {
      this.isLoading = true;

      const newSubscription: ISubscription = {} as ISubscription;

      console.log(this.activationDate);
      
      newSubscription.name = this.name;
      newSubscription.activation_date = this.activationDate?.getTime()!;
      newSubscription.cancellation_date = 0;
      newSubscription.is_active = false;
      newSubscription.discount = 0;
      newSubscription.discount_expiry = 0;
      newSubscription.next_due = this.activationDate?.getTime()!;
      newSubscription.months_to_bill = 1;
      newSubscription.amount = this.selectedPlan!.amount;
      newSubscription.actual_amount = this.selectedPlan!.amount;
      newSubscription.data_download_mtd = 0;
      newSubscription.data_upload_mtd = 0;
      newSubscription.plan = this.selectedPlan;
      newSubscription.customer_id = createObjectKey(
        this.selectedCustomer!.id,
        this.selectedCustomer!.name
      );

      this.subscriptionService
        .insert(newSubscription)
        .then(() => {
          console.log("Subscription create successfully");
          this.router.navigate(["/admin/subscriptions"]);
        })
        .catch((error) => {
          console.error("Error creating subscription:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
